/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  fetchData,
  postData,
  deleteData,
  patchData,
} from "@jda/lui-portal-utilities";

import { createRequestObject, getAuthToken } from "../utility/commonUtility";
import {
  getSubEnterPrisePayload,
  ICreateAccountRequest,
  IDeleteSubEnterpriseRequest,
  IGetSubEnterpriseEntitlement,
  IUpdateEntitlementRequest,
} from "../models/Customers/subEnterprise";

const { MANAGEMENT_SERVICE_URL } = window.env;

export const getAllSubEnterprises = async (
  subEnterprisePayload: getSubEnterPrisePayload
) => {
  const { pageSize, pageNo, searchString, customerId } = subEnterprisePayload;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers/${customerId}/accounts?page-number=${
    pageNo || 1
  }&page-size=${pageSize || 10}&sort-order=ASC&filter-name=${
    searchString || ""
  }`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const createNewAccount = async (data: ICreateAccountRequest) => {
  const { costCenter, displayName, name, customerId, accountKey } = data;
  const payload = { costCenter: +costCenter, displayName, name, accountKey };
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers/${customerId}/accounts`;
  return postData<any>(createRequestObject(apiURL), payload, getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateAccount = async (data: ICreateAccountRequest) => {
  const { displayName, customerId, id } = data;
  const payload = { displayName };
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers/${customerId}/accounts/${id}`;
  return patchData<any>(createRequestObject(apiURL), payload, getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteSubEnterprise = async (
  data: IDeleteSubEnterpriseRequest
) => {
  const { customerId, id } = data;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers/${customerId}/accounts/${id}`;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const getAllEntitlementForSubEnterprise = async (
  data: IGetSubEnterpriseEntitlement
) => {
  const { id, customerId } = data;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers/${customerId}/accounts/${id}/entitlements`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateEntitlementsForSubEnterprise = async (
  data: IUpdateEntitlementRequest
) => {
  const { id, customerId, entitlements } = data;
  const apiURL = `${MANAGEMENT_SERVICE_URL}/customers/${customerId}/accounts/${id}/entitlements`;
  return patchData<any>(createRequestObject(apiURL), entitlements, getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};
